// AxiosInstance.ts
import axios from 'axios';
import { MODEL_TITLE, PYTHON_API_URL } from '../constants/ArrayData';
import { isAutopilotAuth } from '../services/autopilotAuthApi';

export const aurelia_api_uri = PYTHON_API_URL[MODEL_TITLE.indexOf("Aurelia")]
export const GIRIS_BACK_URL = process.env.REACT_APP_GIRIS_BACK_URL || process.env.REACT_APP_BASE_URL;

export const AxiosInstanceCreator = (BASE_URL: string = aurelia_api_uri, prefix: string = "aurelia") => {
  const TOKEN = String(localStorage.getItem("token")) || ""

  const instance = axios.create({
    baseURL: `${BASE_URL}/${prefix}/`,
    timeout: 120000,
    headers: {
      'X-App-Origin': process.env.REACT_APP_ORIGIN_NAME,
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${TOKEN}`,
    },
  });

  instance.interceptors.request.use(
    (config) => {
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return instance;
}

export const AxiosGirisBack = () => {
  const instance = axios.create({
    baseURL: GIRIS_BACK_URL,
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': process.env.REACT_APP_XAPIKEY || '',
    },
  });

  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error)
  );

  return instance;
};

/** Abonnement et paiement Stripe : autopilot-back (nouveau système, clé Stripe de test en dev) quand la connexion du
 *  nouveau système est active, sinon giris-llm-back comme avant. Mêmes routes /subscription des deux côtés. */
export const billingTarget = (): { baseURL: string; apiKey: string } => (isAutopilotAuth()
  ? { baseURL: (process.env.REACT_APP_AUTOPILOT_BACK_URL || '').trim().replace(/\/+$/, ''), apiKey: process.env.REACT_APP_AUTOPILOT_BACK_KEY || '' }
  : { baseURL: GIRIS_BACK_URL || '', apiKey: process.env.REACT_APP_XAPIKEY || '' });

export const AxiosBilling = () => {
  const { baseURL, apiKey } = billingTarget();
  const instance = axios.create({ baseURL, timeout: 30000, headers: { 'Content-Type': 'application/json', 'x-api-key': apiKey } });
  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  });
  return instance;
};
